import React, { FC, useState } from 'react';
import { Form, Upload } from 'antd';
import { UploadProps } from 'antd/lib/upload';
import { FormItemProps } from 'antd/lib/form';
import { useField, FieldHookConfig } from 'formik';
import { RcFile, UploadFile } from 'antd/lib/upload/interface';

export type UploadFieldProps = FieldHookConfig<File | null> & {
  item?: FormItemProps;
  input?: Omit<UploadProps, 'beforeUpload' | 'onChange' | 'showUploadList'>;
  renderContent?: (props: { previewUrl?: string }) => React.ReactNode;
  showFileList?: boolean;
};

export const UploadField: FC<UploadFieldProps> = ({ item, input, renderContent, showFileList = false, ...props }) => {
  const [field, meta, helpers] = useField(props);
  const [previewUrl, setPreviewUrl] = useState<string | undefined>();

  const handleBeforeUpload = (file: RcFile) => {
    helpers.setValue(file);
    const reader = new FileReader();
    reader.onload = (e) => setPreviewUrl(e.target?.result as string);
    reader.readAsDataURL(file);
    return false;
  };

  const handleRemove = () => {
    helpers.setValue(null);
    setPreviewUrl(undefined);
    return true;
  };

  const fileList: UploadFile[] = showFileList && field.value ? [{ uid: '-1', name: (field.value as File).name, status: 'done' } as UploadFile] : [];

  return (
    <Form.Item {...item} validateStatus={meta.touched && !!meta.error ? 'error' : undefined} help={meta.touched ? meta.error : undefined}>
      <Upload {...input} beforeUpload={handleBeforeUpload} onRemove={handleRemove} showUploadList={showFileList} fileList={showFileList ? fileList : undefined} maxCount={1}>
        {renderContent ? renderContent({ previewUrl }) : null}
      </Upload>
    </Form.Item>
  );
};
